import { Moment } from "moment";
import { YearSelector } from "PFComponents/calendar/parts/year_selector";
import { useCallback } from "react";

import { CalendarSelectProps } from "../calendar.types";

type YearsProps = Pick<CalendarSelectProps, "displayMonth" | "setDisplayMonth"> & {
  minDate: Moment;
  maxDate: Moment;
};

export const Years = ({ minDate, maxDate, displayMonth, setDisplayMonth }: YearsProps) => {
  const handleChange = useCallback(
    (year: number) => {
      const newDate = displayMonth.clone().set({ year });

      const isBefore = newDate.isBefore(minDate, "month");
      const isAfter = newDate.isAfter(maxDate, "month");

      if (isBefore) {
        newDate.set({ month: minDate.get("month") });
      }
      if (isAfter) {
        newDate.set({ month: maxDate.get("month") });
      }
      setDisplayMonth(newDate);
    },
    [displayMonth, minDate, maxDate, setDisplayMonth]
  );

  return (
    <YearSelector
      min={minDate.get("year")}
      max={maxDate.get("year") + 1}
      value={displayMonth.get("year")}
      onChange={handleChange}
    />
  );
};
